import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Button from '@zenbusiness/zui/Button';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

import { FAQ_OVERVIEW_URL } from '#client/constants/FAQs';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';

export default function BankingFAQs() {
  const { isDisable } = useDisableDashboardContext();
  const handleClickFAQs = useLinkPressedCallback({
    elementName: 'Banking_FAQ_link',
    elementText: 'Banking_FAQs',
    appPageName: 'active_banking_dashboard',
    elementAsset: 'HelpOutlineOutlinedIcon'
  });

  return (
    <Button
      disabled={isDisable}
      href={FAQ_OVERVIEW_URL}
      icon={<HelpOutlineOutlinedIcon />}
      onClick={handleClickFAQs}
      size="small"
      target="_blank"
      variant="outlined"
    >
      FAQs
    </Button>
  );
}
